import React, { Component } from 'react';
import { Link } from "react-router-dom";
 import { default as minifyCssString } from 'minify-css-string';
 import 'react-photoswipe/lib/photoswipe.css';
  import { PhotoSwipeGallery } from 'react-photoswipe';
import queryString from 'query-string';
import { Helmet } from "react-helmet";

class infox extends Component {
    componentDidMount() {}
    render() {
    		const cssString = `
#magsx{
	    margin-bottom: 80px;
}
.h2rul{
      font-size: 1rem;
    position: relative;
    font-weight: bold;
    font-family: mor; 
    letter-spacing: 1px;
    text-transform: uppercase;
}
.lo {
  display: block;
      font-family: arial; 
    font-size: 16px;
}
#jkm {
	max-width: 980px;
}
.listorder {
  padding-left: 20px;
}
.listorder li{  list-style-type:decimal;


}
#kkti{

    padding-top: 90px;
      font-size: 16px;

    font-family: arial;
    color: #25262a;
       padding-bottom: 30px;
}
#googleMap {
    width: 100%;
    height: 550px;
    margin-bottom: 150px;
}
     
.pswp--animated-in .pswp__bg, .pswp--animated-in .pswp__zoom-wrap {
    -webkit-transition: none;
    transition: none!important;
}
.pswp--animate_opacity {
    opacity: 0.001;
    will-change: opacity;
    transition: none!important;
}
    .pswp__button--share{
  display: none;
 }
    @media (max-width: 992px) {
#jkm {
    max-width: 780px;
}

#kkti {
    padding-top: 50px;
     
      font-size: 15px;
    padding-bottom: 30px;
}
.h2rul{
      font-size: 1rem;
}

}
    @media (max-width: 800px) {

#jkm {
    max-width: 580px;
}


}
    		`      
    		let param = window.location.pathname;
 
    		const items = [{
                  src: '',
                  thumbnail: '',
                  w: 3000,
                  h: 1876
              } 
          ];     
 
    		 const options = {
              //http://photoswi
              bgOpacity: 1,
              showHideOpacity: true,
              closeOnScroll: false,
              preloaderEl: true,
              showAnimationDuration: 0,
              hideAnimationDuration: 0
          };

          const getThumbnailContent = (item) => {
              return (
               


<img id="magsx" isOpen="true"  itemprop="contentUrl"  className="thumb-image loaded" src="https://res.cloudinary.com/forestrun/image/upload/v1554636282/Medal.jpg" />
 
  
              );
          }
        return (

            <div>

       <Helmet>
                <meta charSet="utf-8" />
                <title>Cikole Forest Run | information </title>
                
             </Helmet>

                                      <style dangerouslySetInnerHTML={{__html: minifyCssString(cssString) }} /> 

<div id="jkm" className="container">
             <p id="kkti" className="ops">
             <h2 className="h2rul">INFORMATION</h2><br/>
Race Day: Sunday 8 Desember, 2019<br/>
Tempat: Cikole Jayagiri, Lembang<br/>
Entry Requirement <br/><br/><br/><h2 className="h2rul">Rules & Regulation</h2><br/>   
<ul className="listorder">
<li>             
<span className="lo">Kategori lomba adalah Fun Trail Run dengan jarak tempuh 6.5 KM </span><br/>
</li>
<li>
<span className="lo">Cikole Forest Run 2019 terbuka untuk umum (WNI, Pemegang KITAS maupun WNA)</span><br/>
</li>
<li>
<span className="lo">Para peserta dihimbau untuk mendapatkan rekomendasi medis dari dokter terkait dengan kondisi kesehatan saat menjelang hari lomba.</span><br/>
</li>
<li>
<span className="lo">Cikole Forest Run 2019 akan dibatalkan jika timbul hal-hal diluar kendali pihak penyelenggara (termasuk hujan deras, badai, musibah, demonstrasi, tidak dikeluarkannya izin lomba, ataupun alasan lainnya). Dalam hal Cikole Forest Run 2019 dibatalkan karena hal-hal di luar kendali panitia, maka uang biaya pendaftaran tidak dikembalikan dan penyelenggara tidak bertanggung jawab atas kerugian atau ketidaknyamanan yang timbul.</span><br/>
</li>
<li>
<span className="lo">Setiap peserta memahami sepenuhnya bahwa olahraga ini memiliki resiko yang dapat mengakibatkan cedera, cacat bahkan kematian.</span><br/>
</li>
<li>
<span className="lo">Peserta pendaftar tidak dapat dialih namakan/dipindah tangankan dan bersifat final serta menerima sepenuhnya atas seluruh peraturan dan ketentuan yang berlaku. Barang siapa memberikan nomor lomba (bib) kepada pihak/peserta lain makan peserta akan didiskualifikasi dari perlombaan.</span><br/>
</li>
</ul>
</p>

                                     <div id="googleMap"><iframe frameborder="0" height="100%" scrolling="no" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7923.802243041138!2d107.650764!3d-6.781887!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xf591ada28e64a3ab!2sCikole%20Resort!5e0!3m2!1sen!2sid!4v1570604377486!5m2!1sen!2sid" width="100%"></iframe></div>


              </div>
      </div>

        );
    }
}
export default infox;